/**
 * Videowise shoppable ATC → Rebuy Smart Cart
 * @see https://docs.videowise.com/shoppable-videos/custom-events#videowiseproductaddtocart
 * @see https://developers.rebuyengine.com/reference/smart-cart-methods-base/
 */
(function () {
  'use strict';

  var busy = false;

  function cartRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function wait(ms) {
    return new Promise(function (resolve) {
      setTimeout(resolve, ms);
    });
  }

  function getSmartCart() {
    return window.Rebuy && Rebuy.SmartCart ? Rebuy.SmartCart : null;
  }

  function syncRebuyCart(cart) {
    var smartCart = getSmartCart();
    if (!smartCart || !cart) return;

    try {
      if (typeof smartCart.setCart === 'function') {
        smartCart.setCart(cart);
      }
      if (typeof smartCart.updateCartCount === 'function') {
        smartCart.updateCartCount();
      }
      if (typeof smartCart.updateCartSubtotal === 'function') {
        smartCart.updateCartSubtotal();
      }
    } catch (e) {}
  }

  function fetchCart() {
    return fetch(cartRoot() + 'cart.js')
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        syncRebuyCart(cart);
        document.dispatchEvent(
          new CustomEvent('cart:updated', { bubbles: true, detail: cart })
        );
        document.dispatchEvent(
          new CustomEvent('cart:refresh', { bubbles: true, detail: cart })
        );
        return cart;
      })
      .catch(function () {
        return null;
      });
  }

  function openRebuyCart(attempt) {
    attempt = attempt || 0;
    var smartCart = getSmartCart();

    if (smartCart && typeof smartCart.show === 'function') {
      try {
        // Allow show even if Rebuy would skip auto-open after ATC
        smartCart.skip_open = false;
        smartCart.show();
        return Promise.resolve(true);
      } catch (e) {}
    }

    if (attempt < 20) {
      return wait(150).then(function () {
        return openRebuyCart(attempt + 1);
      });
    }

    var openBtn = document.querySelector(
      '[data-rebuy-cart-toggle], .rebuy-cart-toggle, .header-cart a, .CartToggle'
    );
    if (openBtn) {
      openBtn.click();
      return Promise.resolve(true);
    }

    return Promise.resolve(false);
  }

  function closeVideowisePlayer() {
    window.dispatchEvent(new CustomEvent('videowiseTriggerPlayerClose'));
  }

  /**
   * On classic Shopify, Videowise usually already called /cart/add.js.
   * When Virtual cart / SKIP_CART is enabled, we add the line ourselves.
   */
  function ensureInCart(detail) {
    var variantId = detail.variantId || detail.selectedVariant;
    var qty = parseInt(detail.qty, 10) || 1;
    var shouldAdd =
      window.SKIP_CART === true ||
      (window.videowiseInfo && window.videowiseInfo.customCart === true);

    if (!shouldAdd || !variantId) return Promise.resolve(null);

    return fetch(cartRoot() + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: qty }],
      }),
    }).then(function (res) {
      return res.json();
    });
  }

  // Header cart icon still targets Horizon #cart-drawer — route to Rebuy instead.
  document.addEventListener(
    'click',
    function (event) {
      var trigger = event.target.closest(
        '[data-testid="cart-drawer-trigger"], [aria-controls="cart-drawer"], [on\\:click="#cart-drawer/toggle"], [on\\:click="#cart-drawer/open"]'
      );
      if (!trigger) return;
      if (!(window.Rebuy && Rebuy.SmartCart && typeof Rebuy.SmartCart.show === 'function')) return;

      event.preventDefault();
      event.stopPropagation();
      Rebuy.SmartCart.show();
    },
    true
  );

  window.addEventListener('videowiseProductAddToCart', function (event) {
    if (busy) return;
    busy = true;

    var detail = (event && event.detail) || {};

    closeVideowisePlayer();

    ensureInCart(detail)
      .then(function () {
        // Let Videowise's own /cart/add.js finish when it handles ATC.
        return wait(250);
      })
      .then(function () {
        return fetchCart();
      })
      .then(function () {
        return openRebuyCart(0);
      })
      .catch(function () {
        return openRebuyCart(0);
      })
      .finally(function () {
        busy = false;
      });
  });
})();
